export const getUserLang = () => {
  const lang = sessionStorage.getItem('i18nextLng');
  return lang ? lang : '';
};

export const setUserLang = (lang: string): void => {
  sessionStorage.setItem('i18nextLng', lang);
};

export const getCompany = () => {
  const comp = sessionStorage.getItem('ea-company');
  return comp ? comp : '';
};

export const setCompany = (comp: string): void => {
  sessionStorage.setItem('ea-company', comp);
};

export const getListCodePostal = () => {
  const comp = sessionStorage.getItem('ListCodePostal');
  return comp ? comp : '';
};

export const setListCodePostal = (comp: string): void => {
  sessionStorage.setItem('ListCodePostal', comp);
};

export const getByKey = (key: string) => {
  const comp = sessionStorage.getItem(key);
  return comp ? comp : '';
};


export const deleteByKey = (key: string) => {
  sessionStorage.removeItem(key);
};


export const setValue = (key: string, value: any): void => {
  sessionStorage.setItem(key, value);
};
